import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-text-slate-500 tw-text-sm" }

import { computed, ref } from "vue"
  import { QSelect } from "quasar"
  
  import { EmploymentStatusOptions } from "src/const/select-options"
  
  
export default /*@__PURE__*/_defineComponent({
  __name: 'EmploymentStatusSelect',
  props: {
    modelValue: {
      type: Number,
      default: null,
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:modelValue'
  ],
  setup(__props, { expose: __expose, emit: __emit }) {

  const props = __props

  const value = computed<number | null>({
    get() {
      if (props.modelValue) {
        return props.modelValue
      }
      else {
        return null
      }
    },
    set(value: number | null) {
      emit('update:modelValue', value)
    }
  })

  const emit = __emit

  const employmentStatusRef = ref<QSelect | null>(null);
  function validate(){
    return employmentStatusRef.value!.validate();
  }
  __expose({ validate })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(QSelect), {
    modelValue: value.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
    modelModifiers: { number: true },
    options: _unref(EmploymentStatusOptions),
    ref_key: "employmentStatusRef",
    ref: employmentStatusRef,
    rules: [val => (__props.required === true && !!val) || !__props.required || 'Required'],
    "emit-value": "",
    "label-color": "tw-text-slate-500",
    class: _normalizeClass(["tw-text-slate-500", employmentStatusRef.value?.hasError ? '' : 'tw-shadow-sm']),
    "input-class": "tw-text-slate-500",
    "popup-content-class": "tw-text-sm tw-text-slate-500 limit-dd-height",
    "dropdown-icon": "mdi-chevron-down",
    label: value.value ? undefined : 'Select a status...',
    "map-options": "",
    "data-cy": "employmentStatusSelect",
    outlined: "",
    dense: "",
    "data-clarity-unmask": "true"
  }, {
    selected: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(EmploymentStatusOptions).find(t => t.value === value.value)?.label), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "options", "rules", "class", "label"]))
}
}

})